import _ from 'lodash';

const inStockItems = (state)=>{
  return state.items;
};

const allItems = (state)=>{
  return state.allItems;
};

const inStockItemsBookable = (state) =>{
  return _.filter(state.items, item=>{
    return ((item.in_stock>0 || (item.pending-item.reserved_new_shipement)>0)&&item.inventory.ind_reservation);
  })
}

const inStockItemsByInventory = (state) => (inventoryId) =>{
  return _.filter(state.items, item=>{
    return item.fk_inventory_id==inventoryId;
  })
}


export default {
  inStockItems,
  inStockItemsBookable,
  allItems,
  inStockItemsByInventory
};
